import { CoreEntity } from "./core-entity";


export interface Content extends CoreEntity{
  //[structureFieldName: string]: any;
}
